export default {
  'component.tagSelect.expand': '펼치기',
  'component.tagSelect.collapse': '접기',
  'component.tagSelect.all': '전체',
  'component.deployNotice.expectedEnd': '예상 종료',
  'component.scrollToTop.label': '맨 위로',
  'component.couponStockAlert.title': '쿠폰 수량 소진 — 결제 실패',
  'component.couponStockAlert.member': '회원',
  'component.couponStockAlert.coupon': '쿠폰',
  'component.couponStockAlert.remaining': '남은 수량',
  'component.couponStockAlert.products': '결제하려던 상품',
  'component.couponStockAlert.orderTotal': '주문 금액',
  'component.couponStockAlert.attempts': '시도 {count}회',
  'component.couponStockAlert.andMore': '외 {count}개',
  'component.couponStockAlert.action': '쿠폰 수량을 늘리거나 쿠폰을 마감해 주십시오. 회원은 결제하지 못했습니다.',
  // 자사몰 상품 피커(OwnMallProductPickerModal) 공용 문구
  'component.productPicker.title': '자사몰 상품 등록',
  'component.productPicker.confirm': '선택 상품 추가 ({count})',
  'component.productPicker.searchPlaceholder': '제품명 / OfferId / UniqueNo 검색',
  'component.productPicker.loadFailed': '상품 목록을 불러오지 못했습니다.',
  'component.productPicker.noneSelected': '추가할 상품을 선택해 주세요.',
  'component.productPicker.allStores': '전체 스토어',
  'component.productPicker.totalProducts': '전체 {total}개',
  'component.productPicker.columns.image': '이미지',
  'component.productPicker.columns.title': '상품명',
  'component.productPicker.columns.productNo': '상품번호',
  'component.productPicker.columns.uniqueNo': 'UniqueNo',
  'component.productPicker.columns.salePrice': '판매가',
  // 자사몰 상품 상세 팝업(OwnMallProductDetailModal) 공용 문구
  'component.ownMallProductDetail.title': '자사몰 상품 상세',
  'component.ownMallProductDetail.notFound': '상품을 찾지 못했습니다.',
  'component.ownMallProductDetail.loadFailed': '상품 정보를 불러오지 못했습니다.',
  'component.ownMallProductDetail.field.titleKo': '상품명(한국어)',
  'component.ownMallProductDetail.field.titleEn': '상품명(영어)',
  'component.ownMallProductDetail.field.titleZh': '상품명(중국어)',
  'component.ownMallProductDetail.field.productNo': '상품번호',
  'component.ownMallProductDetail.field.uniqueNo': 'UniqueNo',
  'component.ownMallProductDetail.field.offerId': 'OfferId',
  'component.ownMallProductDetail.field.companyName': '상점명',
  'component.ownMallProductDetail.field.salesStatus': '판매상태',
  'component.ownMallProductDetail.field.displayStatus': '노출상태',
  'component.ownMallProductDetail.field.flags': '표시',
  'component.ownMallProductDetail.field.costPrice': '사입가',
  'component.ownMallProductDetail.field.salePrice': '판매가',
  'component.ownMallProductDetail.field.tagPrice': '태그가',
  'component.ownMallProductDetail.field.marginRate': '마진율',
  'component.ownMallProductDetail.field.stock': '재고',
  'component.ownMallProductDetail.field.createdAt': '등록일',
  'component.ownMallProductDetail.status.onSale': '판매중',
  'component.ownMallProductDetail.status.offSale': '판매중지',
  'component.ownMallProductDetail.status.soldOut': '품절',
  'component.ownMallProductDetail.status.stopped': '중지',
  'component.ownMallProductDetail.status.draft': '임시저장',
  'component.ownMallProductDetail.display.visible': '노출',
  'component.ownMallProductDetail.display.hidden': '숨김',
  'component.ownMallProductDetail.flag.popular': '인기',
  'component.ownMallProductDetail.flag.featured': '추천',
  'component.ownMallProductDetail.flag.newArrival': '신상',
  'component.ownMallProductDetail.flag.bestSeller': '베스트',
  'component.ownMallProductDetail.sku.title': '옵션별 가격·재고',
  'component.ownMallProductDetail.sku.image': '이미지',
  'component.ownMallProductDetail.sku.option': '옵션',
  'component.ownMallProductDetail.sku.noOption': '옵션 없음',
  'component.ownMallProductDetail.sku.empty': '등록된 옵션이 없습니다.',
  'component.ownMallProductDetail.action.openStorefront': '자사몰에서 보기',
  'component.ownMallProductDetail.action.edit': '편집 페이지로 이동',
};
